import React, { useRef } from 'react';

const LABELS = ['Top left', 'Top right', 'Bottom right', 'Bottom left'];

/* Draggable corner handles (positions in % of the stage) for placing a shade on an uploaded photo */
export const CornerEditor = ({ quad, onChange }) => {
  const dragging = useRef(null);

  const toPct = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    return [
      Math.min(100, Math.max(0, ((e.clientX - rect.left) / rect.width) * 100)),
      Math.min(100, Math.max(0, ((e.clientY - rect.top) / rect.height) * 100)),
    ];
  };

  const onMove = (e) => {
    if (dragging.current === null) return;
    const next = quad.map((p, i) => (i === dragging.current ? toPct(e) : p));
    onChange(next);
  };

  return (
    <div
      className="absolute inset-0 z-20 touch-none"
      onPointerMove={onMove}
      onPointerUp={() => { dragging.current = null; }}
      onPointerLeave={() => { dragging.current = null; }}
      data-testid="corner-editor"
    >
      <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 100 100" preserveAspectRatio="none">
        <polygon points={quad.map(p => p.join(',')).join(' ')} fill="none" stroke="rgba(245,158,11,0.9)" strokeWidth="0.4" strokeDasharray="1.2 0.8" vectorEffect="non-scaling-stroke" />
      </svg>
      {quad.map(([x, y], i) => (
        <button
          key={i}
          type="button"
          aria-label={LABELS[i]}
          onPointerDown={(e) => { e.preventDefault(); dragging.current = i; e.currentTarget.parentElement.setPointerCapture?.(e.pointerId); }}
          className="absolute w-6 h-6 -ml-3 -mt-3 rounded-full bg-white border-[3px] border-amber-500 shadow-lg cursor-grab active:cursor-grabbing hover:scale-110 transition-transform"
          style={{ left: `${x}%`, top: `${y}%` }}
          data-testid={`corner-handle-${i}`}
        />
      ))}
    </div>
  );
};

export default CornerEditor;
